<template lang="pug">
.box.full-height.bg-white
  .d-flex.flex-column.height-100
    page-title(:title="$route.meta.title")
      filter-button(
        slot="action",
        @click="$router.push({ name: `${$route.name}.filter` })",
        :filtered="false"
      )
    transition.flex-1(name="slide-fade-y", mode="out-in")
      router-view.scrollable
    .flex-0
      ul.tab.tab-block
        li.tab-item.tooltip(
          v-for="tab in tabs",
          :class="{ active: $route.name === tab.to }",
          :data-tooltip="tab.tooltip"
        )
          a.c-hand(@click="$router.replace({ name: tab.to })")
            i(:class="tab.icon")
            small &nbsp;{{ tab.label }}
</template>

<script>
export default {
  computed: {
    tabs() {
      return [
        {
          to: "app.mensagens",
          icon: "fa fa-inbox",
          tooltip: "Mensagens recebidas",
          label: "Recebidas",
        },
        {
          to: "app.mensagens.enviadas",
          icon: "fa fa-paper-plane",
          tooltip: "Mensagens enviadas",
          label: "Enviadas",
        },
      ];
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../styles/_variables.styl';

.tab {
  border-top: 0.05rem solid #dadee4;
  border-bottom: none;

  .tab-item {
    i {
      font-size: 1.3rem;
    }

    &.active, a, .tab .tab-item a {
      box-shadow: none;
      border-top: 0.1rem solid transparent;
      border-bottom: none;

      &.active {
        border-top-color: primary-color;
        border-bottom-color: transparent;
        color: primary-color;
      }
    }
  }
}
</style>
